import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "black-dialog"
};
const _hoisted_2 = {
  class: "dialog-body"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, watch } from "vue";
export default {
  __name: 'BlackDialog',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: "Tips"
    },
    width: {
      type: String,
      default: "auto"
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    hideConfirm: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    cancelText: {
      type: String,
      default: "取消"
    }
  },
  emits: ["confirm", "cancal"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const showDialog = ref(props.show);
    watch(() => props.show, newValue => {
      showDialog.value = newValue;
    });
    const cancel = () => {
      showDialog.value = false;
      emits("cancal");
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showDialog.value = $event),
        title: __props.title,
        width: __props.width,
        "before-close": cancel
      }, _createSlots({
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])]),
        _: 2
      }, [!__props.hideFooter ? {
        name: "footer",
        fn: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: cancel,
          style: {
            "--el-border-radius-base": "8px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.cancelText), 1)]),
          _: 1
        }), !__props.hideConfirm ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('confirm'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmText), 1)]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        key: "0"
      } : undefined]), 1032, ["modelValue", "title", "width"])]);
    };
  }
};